export const emptyWorkspaceExample = `openapi: 3.1.0
info:
  title: APIFiddle Sample Definition
  description: Example workspace
  version: 0.0.0
paths: {}
`;
